import { PayloadAction } from "@reduxjs/toolkit";
import { put, takeLatest, call, all } from "redux-saga/effects";

import { commonMessages } from "infrastructure/localization";
import { notification } from "infrastructure/notification";

import { messageTranslationsActions } from "./MessageTranslations.actions";
import { getMessageTranslations } from "./MessageTranslations.api";
import { IMessageTranslation } from "./MessageTranslations.state";

function* loadMessageTranslationsExecute({ payload }: PayloadAction<string>) {
  try {
    const translations: IMessageTranslation[] = yield call(getMessageTranslations, payload);
    yield put(messageTranslationsActions.loadMessageTranslationsCompleted(translations));
  } catch (error) {
    yield put(messageTranslationsActions.loadMessageTranslationsFailed(notification.error(error).useMessageId(commonMessages.error("unexpectedError"))));
  }
}

function* actionWatcher() {
  yield takeLatest(messageTranslationsActions.loadMessageTranslations.toString(), loadMessageTranslationsExecute);
}

export function* appSaga() {
  yield all([actionWatcher()]);
}
